import { ButtonLink } from 'braid-design-system';
import type React from 'react';

import Routes from 'src/config/routes';

interface PaymentSuccessCtaProps {
  children: React.ReactNode;
}

export const PaymentSuccessCta = ({ children }: PaymentSuccessCtaProps) => (
  <ButtonLink href={Routes.DASHBOARD} id="next" tone="formAccent">
    {children}
  </ButtonLink>
);
